import { render } from "./CupCake.vue?vue&type=template&id=6dadbca2"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/CupCake.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6dadbca2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6dadbca2', __exports__)) {
    api.reload('6dadbca2', __exports__)
  }
  
  module.hot.accept("./CupCake.vue?vue&type=template&id=6dadbca2", () => {
    api.rerender('6dadbca2', render)
  })

}


export default __exports__